import {observable, action} from 'mobx';
import {createContext} from 'react';

export enum ToastType { SUCCESS, ERROR }

export const UiStateContext = createContext<UiStateStore>(null);

export class UiStateStore {
    @observable toastType: ToastType = null;

    @action public fireToast = (toastType: ToastType) => {
        this.toastType = toastType;
    }
}
